"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSDowngradeReasonModalComponent = void 0;
const core_1 = require("@angular/core");
const constants = require("../../shared/constants");
const downgradereason_service_1 = require("./downgradereason.service");
class CSDowngradeReasonModalComponent {
    constructor(downgradeReasonService) {
        this.downgradeReasonService = downgradeReasonService;
        this.viewModelType = 'DOWNGRADEREASON';
        this.reasonNotSelected = false;
        this.selectedReason = '';
        this.messageEvent = new core_1.EventEmitter();
        this.tenantType = constants.tenantType;
        this.subscriptionBilling = constants.subscriptionBilling;
    }
    ngOnInit() {
        this.getViewModel();
    }
    getViewModel() {
        this.loader = true;
        this.downgradeReasonService.getDowngradeReasonModel(this.viewModelType, null).subscribe((viewModel) => {
            this.loader = false;
            this.downgradeReasonModel = viewModel;
            this.selectedReason = this.downgradeReasonModel.downgradeReasonCode;
            if (viewModel && (viewModel.errorMessages.length > 0)) {
                this.errorMsg = viewModel.errorMessages[0];
                this.messageEvent.emit('downgradeReason - done');
            }
        }, (error) => {
            this.loader = false;
            this.errorMsg = error;
            this.messageEvent.emit('downgradeReason - done');
        });
    }
    closeModal() {
        this.modalReference.close();
    }
    clickedSubmit() {
        this.loader = true;
        if (this.downgradeReasonModel.downgradeReasonCode === null || this.downgradeReasonModel.downgradeReasonCode === '') {
            this.reasonNotSelected = true;
            this.loader = false;
        }
        else {
            this.downgradeReasonService.updateViewModel(this.viewModelType, this.downgradeReasonModel)
                .subscribe((res) => {
                this.loader = false;
                this.messageEvent.emit('downgradeReason - done');
            }, (error) => {
                this.loader = false;
                this.errorMsg = error;
                this.messageEvent.emit('downgradeReason - done');
            });
        }
    }
}
exports.CSDowngradeReasonModalComponent = CSDowngradeReasonModalComponent;
//# sourceMappingURL=downgradereasonmodal.component.js.map